// Depends
import { route, meta } from '@/helpers/routes'
import Professional from './professional/index'

export default [
  route('/professional/public/profile', '/professional/public/profile', Professional, meta('Perfil Publico', false, 'guest', true))
]



// WEBPACK FOOTER //
// ./src/app/profile-public/routes.js